// src/service/Roles.js
//
// Roles y permisos. La colección vive en el API de talleres (no en el de usuarios):
// es el servicio que verifica los permisos en cada request, así que es el que tiene
// que ser dueño de la tabla.

import instance from '../apis/app';

const Roles = {
  /**
   * Los permisos del usuario que está en sesión.
   *
   * Lo pide el AuthProvider al montar. Es lo que reemplaza a deducir el menú del
   * nombre del rol: el panel dibuja exactamente lo que el servidor va a autorizar.
   */
  miSesion: async () => {
    const respuesta = await instance.get('/sesion/permisos');
    return respuesta?.data || null;
  },

  /** Catálogo de módulos con etiqueta y descripción, para la matriz. */
  modulos: async () => {
    const respuesta = await instance.get('/admin/roles/modulos');
    return respuesta?.data?.modulos || [];
  },

  /** Todos los roles, con cuánta gente tiene cada uno. */
  listar: async () => {
    const respuesta = await instance.get('/admin/roles');
    return respuesta?.data || { roles: [], modulos: [] };
  },

  obtener: async key => {
    const respuesta = await instance.get(`/admin/roles/${key}`);
    return respuesta?.data || null;
  },

  crear: async payload => instance.post('/admin/roles', payload),

  actualizar: async (key, payload) => instance.patch(`/admin/roles/${key}`, payload),

  eliminar: async key => instance.delete(`/admin/roles/${key}`),

  /**
   * Los roles que se pueden asignar a una persona, para el selector del panel de
   * Usuarios. Antes esa lista era un array fijo en el componente y había que
   * recompilar el frontend para ofrecer un rol nuevo.
   */
  asignables: async () => {
    const respuesta = await instance.get('/roles/asignables');
    return respuesta?.data?.roles || [];
  },
};

export default Roles;
